export default __webpack_public_path__ + "static/media/Skytr.e549cb42.png";